<template>
  <h-fs-dialog
    :value="show"
    bottom
  >
    <v-card tile light>
      <h-main-toolbar />
      <h-secondary-toolbar />
      <v-divider />
      <v-card-text v-if="! orders.length" class="pa-4">
        <v-skeleton-loader v-if="loading" type="list-item-three-line@6" />
        <h-alert v-else>{{ __('noHistory') }}</h-alert>
      </v-card-text>
      <v-card-text v-else class="pa-0">
        <v-expansion-panels
          v-if="filteredOrders.length"
          v-model="opened"
          accordion
          flat
          multiple
        >
          <v-expansion-panel
            v-for="order in filteredOrders"
            :key="`o${order.id}`"
          >
            <v-expansion-panel-header class="pl-4 pr-3 py-2">
              <template #default="{ open }">
                <h-order-header
                  :order="order"
                  :active="open"
                  :show-date="! date"
                />
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <h-order-contents
                :contents="order.orderContents"
                disabled
                closed
                color="grey lighten-5"
                class="my-4"
              />
              <h-order-invoice
                v-for="invoice in order.orderInvoices"
                :key="`i${invoice.id}`"
                :invoice="invoice"
                :refund="order.refunded_invoice_id !== null"
                class="mt-2"
              />
              <h-order-actions :order="order" />
            </v-expansion-panel-content>
            <v-divider />
          </v-expansion-panel>
        </v-expansion-panels>
        <div v-else class="pa-4">
          <h-alert>{{ __('noHistory') }}</h-alert>
        </div>
        <v-skeleton-loader
          v-if="loading"
          type="list-item-three-line@6"
        />
        <v-skeleton-loader
          v-else-if="loadMoreOrders"
          v-intersect="onIntersect"
          type="list-item-three-line@3"
        />
      </v-card-text>
    </v-card>
  </h-fs-dialog>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Currenciable from '@/Mixins/Currenciable'
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HFsDialog from '@/Components/FullScreenDialog'
  import HAlert from '@/Components/Messages/Alert'
  import HMainToolbar from './Toolbars/Main'
  import HSecondaryToolbar from './Toolbars/Secondary'
  import HOrderHeader from './Orders/Header'
  import HOrderContents from '@/Sections/Order/Contents/List'
  import HOrderInvoice from './Orders/Invoice'
  import HOrderActions from './Orders/Actions/List'

  export default {
    mixins: [
      Currenciable,
      I18n,
      UsesIcons,
    ],

    components: {
      HFsDialog,
      HAlert,
      HMainToolbar,
      HSecondaryToolbar,
      HOrderHeader,
      HOrderContents,
      HOrderInvoice,
      HOrderActions,
    },

    data: () => ({
      opened: [],
    }),

    computed: {
      ...mapState('history', [
        'show',
        'date',
        'orders',
        'loading',
        'loadMoreOrders',
      ]),
      ...mapGetters('history', {
        filteredOrders: 'orders',
      }),
    },

    watch: {
      filteredOrders (v) {
        this.opened = v.length === 1 ? [0] : []
      },
    },

    methods: {
      onIntersect (entries) {
        if (entries[0].isIntersecting) {
          this.$store.dispatch('history/fetch')
        }
      },
    },
  }
</script>
